let cachedHost: string;

export const getApiHost = () => {
  if (cachedHost !== null && cachedHost !== undefined) {
    return cachedHost;
  }

  const _host = window.location.host;

  cachedHost = _host?.startsWith("www")
    ? process.env.REACT_APP_API_URL_W || 'empty_url'
    : process.env.REACT_APP_API_URL || 'empty_url';

  return cachedHost;
};